<template>
  <section class="service-area pt-120 pb-100">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-8">
          <div class="section-title text-center mb-70">
            <h2>{{ content.header.title }}</h2>
            <p>{{ content.header.description }}</p>
          </div>
        </div>
      </div>
      <div class="row g-2 g-md-4">
        <div
          class="col-lg-4 col-md-6 h-auto"
          v-for="(service, index) in content.services"
          :key="index"
        >
          <div class="service-item mb-30 h-100">
            <div class="service-thumb">
              <img :src="service.image" alt="" />
            </div>
            <div class="service-content">
              <div class="service-icon">
                <i :class="service.icon"></i>
              </div>
              <h4>
                <router-link :to="'/technology-details/' + service.slug">{{
                  service.title
                }}</router-link>
              </h4>
              <p>{{ service.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TechItsOurOfferingComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url("https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");

.service-area {
  position: relative;
  z-index: 1;
  padding-top: 120px;
  padding-bottom: 100px;
  background: linear-gradient(145deg, #00061a, #071b24);
  color: #fff;
}

.section-title {
  margin-bottom: 70px;
}

.section-title h2 {
  font-size: 40px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5);
}

.section-title p {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.8;
}

.section-title.text-center {
  text-align: center;
}

.service-item {
  position: relative;
  z-index: 1;
  margin-bottom: 30px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(246, 236, 79, 0.1);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  border-radius: 15px;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
}

.service-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(246, 236, 79, 0.2);
  border-color: rgba(246, 236, 79, 0.3);
}

.service-thumb {
  position: relative;
  z-index: 1;
  overflow: hidden;
}

.service-thumb img {
  width: 100%;
  display: block;
  transition: transform 0.3s ease-in-out;
}

.service-item:hover .service-thumb img {
  transform: scale(1.1);
}

.service-content {
  position: relative;
  z-index: 1;
  padding: 30px;
}

.service-icon {
  position: relative;
  z-index: 1;
  margin-bottom: 25px;
}

.service-icon i {
  font-size: 40px;
  color: #f6ec4f;
}

.service-content h4 {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 15px;
}

.service-content h4 a {
  color: #fff;
  text-decoration: none;
  transition: color 0.3s ease-in-out;
}

.service-content h4 a:hover {
  color: #f6ec4f;
}

.service-content p {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.8;
  margin-bottom: 20px;
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .service-area {
    padding: 80px 0;
  }
}

@media only screen and (max-width: 767px) {
  .service-area {
    padding: 60px 0;
  }
  
  .section-title h2 {
    font-size: 32px;
  }
  
  .service-content {
    padding: 25px;
  }
  
  .service-content h4 {
    font-size: 20px;
  }
  
  .service-content p {
    font-size: 14px;
  }
}

@media only screen and (max-width: 399px) {
  .service-area {
    padding: 40px 0;
  }
  
  .section-title h2 {
    font-size: 28px;
  }
}
</style>
